module.exports = __webpack_public_path__ + "img/P4-0-6.bb84bec6.svg";